import { Action, State } from '../types';
import {
    ADD_COMMENT, ADD_REPLY, CLOSE_USER_FORM, GET_COMMENTS, HIDE_WIDGET, OPEN_USER_FORM,
    REMOVE_COMMENT, REMOVE_REPLY, SELECT_COMMENT, SET_COMMENTS, SET_META_TAGS, SET_PRODUCT_INFO,
    SET_THEME_MODE, SET_WIDGET_ID
} from './actions';

export const initialState: State = {
  data: {
    limit: 0,
    offset: 0,
    total: 0,
    data: [],
  },
  loading: true,
  selectedCommentId:'',
  productInfo: undefined,
  widgetId: '',
  metaTags: {},
  themeMode: 'light',
  hideWidget: false,
  userForm: {
    isOpen: false,
    commentText: '',
    label: 'Post my reply'
  }
};

export const reducer = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case GET_COMMENTS: 
      return {...state, loading: true}
    case SET_WIDGET_ID:
      return { ...state, widgetId: action.payload.widgetId };
    case SET_COMMENTS:
      return { ...state, data: action.payload, loading: false };
    case ADD_COMMENT:
      return { ...state, data: { ...state.data, data: [...state.data.data, action.payload] } };
    case REMOVE_COMMENT:
      return { ...state, data: { ...state.data, data: state.data.data.filter(comment => comment.id !== action.payload) } };
    case ADD_REPLY:
      return {
        ...state,
        data: {
          ...state.data,
          data: state.data.data.map(comment =>
            comment.id === action.payload.commentId
              ? { ...comment, replies: [...comment.replies, action.payload.reply] }
              : comment
          ),
        },
      };
    case REMOVE_REPLY:
      return {
        ...state,
        data: {
          ...state.data,
          data: state.data.data.map(comment =>
            comment.id === action.payload.commentId
              ? {
                  ...comment,
                  replies: comment.replies.filter(reply => reply.id !== action.payload.replyId),
                }
              : comment
          ),
        },
      };
    case SELECT_COMMENT:
        return {
            ...state,
            selectedCommentId: action.payload.commentId,
        };
    case SET_PRODUCT_INFO: 
        return {
            ...state,
            productInfo: action.payload.product,
        };
    case SET_META_TAGS:
      console.log('updating meta tags', action)
      return {
        ...state,
        metaTags: action.payload
      }
    case SET_THEME_MODE:
      if(state.productInfo?.widget_theme === 'default' || state.productInfo?.widget_theme === null) {
      return {
        ...state,
        themeMode: action.payload.mode
      }
    } else {
      return {
        ...state,
        themeMode: state.productInfo?.widget_theme || 'light'
      }
    }
    case HIDE_WIDGET:
      return {
        ...state,
        hideWidget: true
      }
    case OPEN_USER_FORM:
      return {
        ...state,
        userForm: {
          isOpen: true,
          commentText: action.payload.commentText || '',
          label: action.payload.label || 'Post my reply',
          onSuccess: action.payload.onSuccess,
          onClose: action.payload.onClose
        }
      };
    case CLOSE_USER_FORM:
      return {
        ...state,
        userForm: {
          ...state.userForm,
          isOpen: false
        }
      };
    default:
      return state;
  }
};
